var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainnew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#595959",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.287 23.654h-2.544l-4.17-1.887v-1.573c0-.17.145-.314.315-.314h6.543c.997 0 1.81.812 1.81 1.808a1.96 1.96 0 0 1-1.954 1.966zM15.568 13.864H7.465a.498.498 0 0 1-.498-.498V7.429c0-.183.144-.34.34-.34h8.314c.21 0 .367.17.367.366v5.976a.417.417 0 0 1-.42.433z",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.351,
    cy: 1.35,
    rx: 1.351,
    ry: 1.35,
    opacity: 0.18,
    transform: "translate(12.54 16.079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.944 14.388H8.174a.968.968 0 0 1-.971-.97V8.661c0-.537.433-.97.97-.97h12.758c.538 0 .97.433.97.97v4.757c0 .538-.432.97-.957.97zm-12.77-5.78a.056.056 0 0 0-.053.053v4.757c0 .027.026.053.052.053h12.758a.056.056 0 0 0 .053-.053V8.661a.056.056 0 0 0-.053-.052H8.173zM14.559 18.818a2.02 2.02 0 0 1-2.02-2.018 2.02 2.02 0 0 1 4.039 0 2.011 2.011 0 0 1-2.02 2.018zm0-3.106c-.603 0-1.102.498-1.102 1.1 0 .604.499 1.102 1.102 1.102.603 0 1.101-.498 1.101-1.101s-.498-1.101-1.101-1.101zM18.78 22.37h-8.443a.464.464 0 0 1-.46-.459c0-.249.21-.459.46-.459h8.444c.249 0 .459.21.459.459 0 .249-.21.459-.46.459z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.43 20.6H7.687A2.691 2.691 0 0 1 5 17.914v-9.41c0-1.193.8-2.255 1.954-2.582l5.677-1.625a7.622 7.622 0 0 1 4.3.026l5.285 1.586c1.154.34 1.914 1.376 1.914 2.582v9.423c0 1.48-1.219 2.686-2.7 2.686zM7.202 6.8a1.781 1.781 0 0 0-1.285 1.704v9.41c0 .983.8 1.769 1.77 1.769h13.754c.984 0 1.77-.8 1.77-1.77V8.478c0-.786-.51-1.467-1.258-1.703L16.67 5.2a6.73 6.73 0 0 0-3.777-.026L7.203 6.8zM6.718 26a.442.442 0 0 1-.223-.066.456.456 0 0 1-.17-.629l1.573-2.726a.456.456 0 0 1 .63-.17.456.456 0 0 1 .17.63l-1.574 2.725a.496.496 0 0 1-.406.236zM22.19 26a.433.433 0 0 1-.394-.236l-1.573-2.726a.456.456 0 0 1 .17-.629.456.456 0 0 1 .63.17l1.573 2.726a.456.456 0 0 1-.17.63.534.534 0 0 1-.236.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.138 24.152h-7.106a.419.419 0 0 1-.184-.04L6.823 22.33a.457.457 0 0 1-.276-.419v-1.782c0-.25.21-.46.46-.46.248 0 .458.21.458.46v1.48l3.671 1.613h6.91l3.606-1.612v-1.154c0-.249.21-.458.46-.458.248 0 .458.21.458.458v1.455c0 .183-.105.34-.275.42l-3.973 1.782a.419.419 0 0 1-.184.04zM18.322 8.622h-7.867a.464.464 0 0 1-.46-.46c0-.248.21-.458.46-.458h7.867c.249 0 .459.21.459.459 0 .249-.21.459-.46.459z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainnew);
export default __webpack_public_path__ + "static/media/trainnew.e87661816df3c0e4ae5b343b49fb519f.svg";
export { ForwardRef as ReactComponent };